module.exports = __webpack_public_path__ + "static/sell-force-f2c6dc686b15ec90bea394328a521182.png";